import React from "react";

export const MostlySunnyIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="34" fill="#3F4447">
                <g transform="translate(2.000000, 2.000000)">
                    <rect
                        transform="translate(5.000000, 38.500000) rotate(-270.000000) translate(-5.000000, -38.500000) "
                        x="3.5"
                        y="33.5"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(61.596194, 61.596194) rotate(-225.000000) translate(-61.596194, -61.596194) "
                        x="60.0961941"
                        y="56.5961941"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(14.596194, 14.596194) rotate(-225.000000) translate(-14.596194, -14.596194) "
                        x="13.0961941"
                        y="9.59619408"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(38.500000, 71.000000) rotate(-180.000000) translate(-38.500000, -71.000000) "
                        x="37"
                        y="66"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(38.500000, 5.000000) rotate(-180.000000) translate(-38.500000, -5.000000) "
                        x="37"
                        y="0"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(14.596194, 61.596194) rotate(-135.000000) translate(-14.596194, -61.596194) "
                        x="13.0961941"
                        y="56.5961941"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(61.596194, 14.596194) rotate(-135.000000) translate(-61.596194, -14.596194) "
                        x="60.0961941"
                        y="9.59619408"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <path
                        d="M54.2579841,49.1939372 C50.5852707,54.957802 44.3362647,58.5 37.5,58.5 C26.4621212,58.5 17.5,49.3294573 17.5,38 C17.5,26.6705427 26.4621212,17.5 37.5,17.5 C44.3512026,17.5 50.6121025,21.0578146 54.2810145,26.8422893 C54.7247331,27.5418644 55.6515558,27.749277 56.3511308,27.3055583 C57.0507059,26.8618397 57.2581185,25.935017 56.8143999,25.235442 C52.6035022,18.5964625 45.3947112,14.5 37.5,14.5 C24.7896345,14.5 14.5,25.0289284 14.5,38 C14.5,50.9710716 24.7896345,61.5 37.5,61.5 C45.3775087,61.5 52.5727068,57.4214607 56.7880139,50.8060628 C57.2331902,50.1074144 57.0277103,49.1801613 56.3290619,48.7349851 C55.6304134,48.2898089 54.7031604,48.4952887 54.2579841,49.1939372 Z"
                        fillRule="nonzero"
                    />
                    <path
                        d="M77.5,40.556928 C77.5,44.3972822 74.3437157,47.5 70.4629566,47.5 L52.4675655,47.5 C52.3428282,47.5 52.2216472,47.4847743 52.1057793,47.45608 C48.6059914,47.0660882 45.9117647,44.136101 45.9117647,40.6070637 C45.9117647,37.0632713 48.6188506,34.1522169 52.0943177,33.7592603 C53.3292192,29.525984 57.287697,26.5 61.8896521,26.5 C66.4723064,26.5 70.4219353,29.5017198 71.6722072,33.7160501 C74.9786479,34.2813452 77.5,37.1245115 77.5,40.556928 Z M70.4629501,44.5 C72.6982468,44.5 74.5,42.728825 74.5,40.556928 C74.5,38.3850309 72.6982468,36.6138559 70.4632696,36.6138559 C69.7301572,36.6140088 69.1056565,36.0876063 68.9821399,35.3674109 C68.4056164,32.0058415 65.4190334,29.5 61.8896521,29.5 C58.3243164,29.5 55.3173366,32.0561573 54.7817021,35.4614687 C54.6606417,36.2311133 53.9705091,36.7799476 53.1933697,36.7246045 C53.0954833,36.7176336 52.9969281,36.7141273 52.8978069,36.7141273 C50.6906839,36.7141273 48.9117647,38.4628557 48.9117647,40.6070637 C48.9117647,42.6371549 50.5128379,44.330239 52.5816227,44.4880023 C52.617716,44.4907547 52.6534303,44.4947691 52.6887236,44.5 L70.4629501,44.5 Z"
                        fillRule="nonzero"
                    />
                </g>
            </g>
        </g>
    </svg>
);
